// extracted by mini-css-extract-plugin
export var actionButton = "_j6-t";
export var buttonContainer = "_j6-0";
export var buttonContainer2 = "_j6-1";
export var buttonSection = "_j6-2";
export var details = "_j6-3";
export var dropdownItem = "_j6-5";
export var dropdownItemsContainer = "_j6-4";
export var fileInput = "_j6-r";
export var headerButton = "_j6-6";
export var icon = "_j6-7";
export var input = "_j6-8";
export var macroListItem = "_j6-9";
export var mainContent = "_j6-a";
export var microText = "_j6-b";
export var modal = "_j6-w";
export var optionsButton = "_j6-c";
export var paperclip = "_j6-s";
export var pillContent = "_j6-d";
export var preview = "_j6-e";
export var preview2 = "_j6-f";
export var quillEditor = "_j6-q";
export var selectedMacro = "_j6-g";
export var sidebar = "_j6-h";
export var sidebarHeader = "_j6-j";
export var sidebarList = "_j6-i";
export var sidebarListItem = "_j6-k";
export var sidebarSearch = "_j6-l";
export var snoozeDurationWrapper = "_j6-v";
export var statusPillContainer = "_j6-m";
export var tagsContainer = "_j6-n";
export var unselectedMacro = "_j6-o";
export var variable = "_j6-u";
export var wrapper = "_j6-p";